import { render, staticRenderFns } from "./CoozzyFileIcon.vue?vue&type=template&id=d065ae4e&scoped=true"
import script from "./CoozzyFileIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyFileIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFileIcon.vue?vue&type=style&index=0&id=d065ae4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d065ae4e",
  null
  
)

export default component.exports